/* eslint-disable react-hooks/exhaustive-deps */
import { Image } from "react-bootstrap";
import { useBetween } from "use-between";

import ItemImage from "../../assets/images/collection/product.png";
import { TrashIcon } from "../icons";
import useApi from "../../pages/useApi";
import { toast } from "react-toastify";
import { toTwoDecimals } from "../../plugins";
import { useNavigate } from "react-router-dom";

export function customOperation(a, b) {
    if (a % 5 === 0) {
        return 5;
    } else if (a % 2 === 1) {
        const remainder = b % a;
        const half = Math.floor(a / 2);

        if (remainder === half) {
            return remainder + 1;
        }
        if (remainder > half) {
            return half;
        }

    } else {
        return (a / 2);
    }
}


const CartItem = ({ item }) => {
    const { cart, updateCart, setUpdating, linePricingByProductId } = useBetween(useApi);
    const navigate = useNavigate();
    const productId = String(item?.InventoryID?.value ?? "");
    const cartQuantity =
        cart?.products?.find((product) => product.productId === productId)?.quantity ??
        linePricingByProductId?.[productId]?.quantity ??
        0;
    const linePricing = linePricingByProductId?.[productId];
    const lineTotal = linePricing
        ? Number(linePricing.lineTotal || 0)
        : Number((item?.DefaultPrice?.value || 0) * cartQuantity);
    const lineSubtotal = linePricing ? Number(linePricing.lineSubtotal || 0) : lineTotal;
    const hasDiscount = Boolean(linePricing && Number(linePricing.lineDiscount || 0) > 0);
    const addToCart = (item) => {
        setUpdating(true);
        let formData = {};
        const products = cart.products;
        const duplicatedId = products.findIndex(
            (product) => product.productId === productId
        );
        const quantityToAdd = item.Casesize.value <= 5 ? item.Casesize.value : customOperation(item.Casesize.value, products[duplicatedId].quantity)

        products[duplicatedId].quantity =
            products[duplicatedId].quantity + quantityToAdd;
        formData = {
            sessionId: cart.customerId,
            customerId: cart.customerId,
            products: [...products]
        };

        updateCart(cart._id, formData)
            .then(() => {
                // toast.success("Cart Updated");
                setUpdating(false);
            })
            .catch((err) => {
                toast.error(err.message);
                setUpdating(false);
            });
    };

    const removeToCart = (item) => {
        setUpdating(true);
        let formData = {};
        const products = cart.products;
        const duplicatedId = products.findIndex(
            (product) => product.productId === productId
        );
        const quantityToRemove = item.Casesize.value <= 5 ? item.Casesize.value : customOperation(item.Casesize.value, products[duplicatedId].quantity)

        if (products[duplicatedId].quantity <= item.Casesize.value) {
            products.splice(duplicatedId, 1);
        } else {
            products[duplicatedId].quantity =
                products[duplicatedId].quantity - quantityToRemove;
        }

        formData = {
            sessionId: cart.customerId,
            customerId: cart.customerId,
            products: [...products]
        };
        updateCart(cart._id, formData)
            .then(() => {
                // toast.success("Cart Updated");
                setUpdating(false);
            })
            .catch((err) => {
                toast.error(err.message);
                setUpdating(false);
            });
    };

    const removeProduct = (item) => {
        setUpdating(true);

        let formData = {};
        const products = cart.products;
        const duplicatedId = products.findIndex(
            (product) => product.productId === productId
        );
        products.splice(duplicatedId, 1);
        formData = {
            sessionId: cart.customerId,
            customerId: cart.customerId,
            products: [...products]
        };
        updateCart(cart._id, formData)
            .then(() => {
                setUpdating(false);
            })
            .catch((err) => {
                toast.error(err.message);
                setUpdating(false);
            });
    };

    return (
        <div className='cart-item' data-attr={item._id}>
            <div className='cart-product-content'>
                <div className='cart-product-image'>
                    <div className='img-wrapper'>
                        {item
                            .Primaryproductimagefirstdisplayed.value ? (
                            <Image
                                src={
                                    item
                                        .Primaryproductimagefirstdisplayed.value
                                }
                                alt='product'
                            />
                        ) : (
                            <Image src={ItemImage} alt='product' />
                        )}
                    </div>
                </div>
                <div className='cart-item-wrapper'>
                    <h6>
                        <button
                            type='button'
                            className='cart-item-link'
                            onClick={() =>
                                navigate(
                                    `/product/${productId}`
                                )
                            }
                        >
                            {`${item.Brand.value} | ${item.Buyermenuproductname.value}`}
                        </button>
                    </h6>
                    <button
                        type='button'
                        className='cart-item-name cart-item-link'
                        onClick={() =>
                            navigate(
                                `/product/${productId}`
                            )
                        }
                    >
                        {item.StrainDescription.value}
                        {item.Phenotype ? (
                            <span
                                className='green-tg'
                                data-phenotype={
                                    item.Phenotype
                                }
                            >
                                <span>
                                    {item.Phenotype.charAt(0).toUpperCase()}
                                </span>
                            </span>
                        ) : null}
                    </button>
                    <div className='product-price-info d-inline-flex'>
                        {/* <label className='price-per-unit'>{`$${toTwoDecimals(
                        item.DefaultPrice.value
                    )} / unit`}</label> */}
                        {linePricing?.promotionType === "DISCOUNT" && linePricing?.discountedUnitPrice !== undefined ? (
                            <>
                                <label className='price-per-unit origin'>{`$${toTwoDecimals(
                                    linePricing.originalUnitPrice
                                )}`}</label>
                                <label className='price-per-unit'>{`$${toTwoDecimals(
                                    linePricing.discountedUnitPrice
                                )}`}</label>
                            </>
                        ) : (
                            <label className='price-per-unit'>{`$${toTwoDecimals(
                                item.DefaultPrice?.value
                            )}`}</label>
                        )}
                        <label className='offered-price-info'>{`$${toTwoDecimals(
                            item.DefaultPrice?.value *
                            item.Casesize.value
                        )} / case (${item.Casesize.value
                            } units)`}</label>
                    </div>
                    {linePricing?.promotionType === "DISCOUNT" ? (
                        <div className='mt-1'>
                            <small className='text-success'>
                                {linePricing.discountType === "PERCENTAGE"
                                    ? `Discount applied: ${linePricing.discountValue}% off`
                                    : `Discount applied: $${toTwoDecimals(linePricing.discountValue || 0)} off`}
                            </small>
                        </div>
                    ) : null}
                    {linePricing?.promotionType === "BOGO" && linePricing?.discountedQuantity > 0 ? (
                        <div className='mt-1'>
                            {linePricing.discountedUnitPrice === 0 ? (
                                <small className='text-success'>
                                    {`BOGO applied: ${linePricing.freeQuantity} free (auto-applied)`}
                                </small>
                            ) : linePricing.discountedUnitPrice ? (
                                <small className='text-success'>
                                    {`BOGO applied: ${linePricing.discountedQuantity} discounted @ $${toTwoDecimals(
                                        linePricing.discountedUnitPrice
                                    )} (auto-applied)`}
                                </small>
                            ) : (
                                <small className='text-success'>
                                    {`BOGO applied: ${linePricing.discountedQuantity} discounted (auto-applied)`}
                                </small>
                            )}
                        </div>
                    ) : null}
                    <div className='qty-container d-inline-flex align-items-center'>
                        <div className='qty-wrapper'>
                            <span
                                onClick={() => {
                                    removeToCart(item);
                                }}
                                className='cursor-pointer qty'
                            >
                                -
                            </span>
                            <span
                                className='qty-value'>{cartQuantity}</span>
                            <span
                                onClick={() => {
                                    addToCart(item);
                                }}
                                className='cursor-pointer qty'
                            >
                                +
                            </span>
                        </div>
                        <div className='d-flex ml-4 price-container'>
                            <p className=''>
                                {hasDiscount ? (
                                    <span className='origin me-2'>{`$${toTwoDecimals(lineSubtotal)}`}</span>
                                ) : null}
                                {`$${toTwoDecimals(lineTotal)}`}
                            </p>
                        </div>
                    </div>
                    {linePricing?.promotionType === "BOGO" && linePricing?.discountedQuantity > 0 ? (
                        <div className='promotion-breakdown'>
                            <small className='text-muted'>
                                {`Paid: ${linePricing.chargedQuantity} • `}
                                {linePricing.discountedUnitPrice === 0
                                    ? `Free: ${linePricing.freeQuantity}`
                                    : `Discounted: ${linePricing.discountedQuantity}`}
                            </small>
                        </div>
                    ) : null}
                </div>
            </div>
            <div className='cart-image-action'>
                <span
                    className='btn-remove'
                    onClick={() => {
                        removeProduct(item);
                    }}
                >
                    <TrashIcon width='24' height='24' />
                </span>
            </div>
        </div>
    );
};

export default CartItem;
